// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-info-panel {
  font-size: 0.75rem;
}

.debug-info-toggle {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  cursor: pointer;
  padding: 5px 10px;
}

.debug-info-content {
  max-height: 120px;
  overflow-y: auto;
  padding: 5px;
  border: 1px solid #ccc;
}

.debug-info-content h3 {
  margin: 0;
  padding: 0;
}

.debug-info-content pre {
  margin: 0;
  white-space: pre-wrap; /* To wrap long text */
}
`, "",{"version":3,"sources":["webpack://./src/components/Debug/DebugInfoPanel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,qBAAqB,EAAE,sBAAsB;AAC/C","sourcesContent":[".debug-info-panel {\n  font-size: 0.75rem;\n}\n\n.debug-info-toggle {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n\n.debug-info-content {\n  max-height: 120px;\n  overflow-y: auto;\n  padding: 5px;\n  border: 1px solid #ccc;\n}\n\n.debug-info-content h3 {\n  margin: 0;\n  padding: 0;\n}\n\n.debug-info-content pre {\n  margin: 0;\n  white-space: pre-wrap; /* To wrap long text */\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `debug-info-panel`;
export { _1 as "debug-info-panel" };
var _2 = `debug-info-toggle`;
export { _2 as "debug-info-toggle" };
var _3 = `debug-info-content`;
export { _3 as "debug-info-content" };
export default ___CSS_LOADER_EXPORT___;
